import { render, staticRenderFns } from "./TeacherLicense.vue?vue&type=template&id=72f13f69"
import script from "./TeacherLicense.vue?vue&type=script&lang=js"
export * from "./TeacherLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f13f69')) {
      api.createRecord('72f13f69', component.options)
    } else {
      api.reload('72f13f69', component.options)
    }
    module.hot.accept("./TeacherLicense.vue?vue&type=template&id=72f13f69", function () {
      api.rerender('72f13f69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/TeacherLicense.vue"
export default component.exports